import React, { Fragment } from "react";
import { Container, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./loadingView.css";

const LoadingView = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <Container fluid id="loadingView">
                <div>
                    <Image src="/images/pt_logo.svg" alt="pole therapy logo" />
                    <p>
                        {t("loading")}
                        <span className="first">.</span>
                        <span className="second">.</span>
                        <span className="third">.</span>
                    </p>
                </div>
            </Container>
        </Fragment>
    );
};

export default LoadingView;
